import React from 'react';

import Select from 'react-select';
import {Col, Form, Row} from "react-bootstrap";
import classes from "./Opportunity.module.css";
import {translation} from "../../../../I18n/i18n";


const OpportunitySelect = (props) => {

    const formatGroupLabel = data => (
        <div style={groupStyles}>
            <span>{data.label}</span>
            <span style={groupBadgeStyles}>{data.options.length}</span>
        </div>
    );
    const groupBadgeStyles = {
        backgroundColor: '#EBECF0',
        borderRadius: '2em',
        color: '#172B4D',
        display: 'inline-block',
        fontSize: 12,
        fontWeight: 'normal',
        lineHeight: '1',
        minWidth: 1,
        padding: '0.16666666666667em 0.5em',
        textAlign: 'center',
    };
    const groupStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    };

    let defaultValue = !props.isToBeCloned ? [{value: props.element, label: props.element.name._text}][0] : null;

    return (
        <Form>
            <Form.Group as={Row}>
                <Form.Label column sm="3">
                    {translation(props.lang, "Opportunity")}
                    <span className={classes.requiredField}>*</span>
                </Form.Label>
                <Col sm="9" className={classes.selectOpportunity}>
                    <Select
                            placeholder={translation(props.lang, "Select")}
                            isDisabled={!props.isToBeCloned}
                            defaultValue={defaultValue}
                            onChange={(e) => {
                                props.element.name = e.value.name;
                                props.element.id = e.value.id;
                                props.element.client = e.value.client;
                                props.mandatoryInformationFilled()
                            }}
                            options={props.opportunities}
                            formatGroupLabel={formatGroupLabel}
                    />
                </Col>
            </Form.Group>
        </Form>

    );
};

export default OpportunitySelect;
